import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { notificationInit } from '../../modules/notifications/actions';
import { getIcepacksFillersRequest } from '../../api/requests';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { DISMISS_TIME } from '../../api/constants';
import {
	GET_ICEPACKS_FILLERS,
	setIcepacksFillersAction,
	setIsIcepacksFillersLoadingAction,
	setPaginationAction,
} from './actions';
import { errorHandler } from '../../api/utils';

export function* getIcepacksFillersSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsIcepacksFillersLoadingAction(true));
		}
		const { data, meta, message, toast } = yield call(getIcepacksFillersRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(
				setIcepacksFillersAction(
					data?.map(icepackFiller => ({
						...icepackFiller,
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=icepack_filler&id=${icepackFiller.id}`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsIcepacksFillersLoadingAction(false));
	}
}

export default function* icepacksFillersContainerSaga() {
	yield takeEvery(GET_ICEPACKS_FILLERS, getIcepacksFillersSaga);
}
